import { ArrowRight, FileText } from "lucide-react";

const ApplicationCard = ({ application, navigate }) => (
    <div className="p-6 hover:bg-gray-50 transition-colors duration-300 group cursor-pointer" onClick={() => navigate('/my-applications')}>
        <div className="flex justify-between items-center">
            <div className="flex-1">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                        <FileText className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h4 className="font-bold text-secondary-800 group-hover:text-primary-700 transition-colors duration-300">
                            {application.job_title}
                        </h4>
                        <p className="text-sm text-secondary-600 mt-1">{application.description}</p>
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-4">
                 <span className="text-xs text-gray-500">{new Date(application.timestamp).toLocaleDateString()}</span>
                <ArrowRight className="w-4 h-4 text-secondary-400 group-hover:text-secondary-600 group-hover:translate-x-1 transition-all duration-300" />
            </div>
        </div>
    </div>
);

export default ApplicationCard;